/**
 * @Author          : SuXiao xiao.su_ext@novartis.com
 * @Date            : 2024-10-09 18:43:02
 * @LastEditors     : SuXiao xiao.su_ext@novartis.com
 * @LastEditTime    : 2025-03-03 09:35:34
 * @FilePath        : \wecom-front-end-admin-portal\src\router\nuoxiaoer.routes.ts
 * @Description     : [诺小二AI] 相关路由
 * @
 */
import { Role } from '@/model/schema';

const routes = [
  {
    path: '/nuoxiaoer',
    name: 'nuoxiaoer',
    component: () => import('../views/nuoxiaoerAI/NuoxiaoerIndex.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '诺小二AI',
      titleEn: 'nuoxiaoer'
    }
  },
  {
    path: '/documentManagement',
    name: 'nuoxiaoerArticleList',
    component: () => import('../views/nuoxiaoerAI/article/ArticleList.vue'),
    meta: {
      roles: [],
      auth: true,
      title: '文档管理',
      titleEn: 'documentManagement'
    }
  },
  {
    path: '/addDocument',
    name: 'nuoxiaoerDocumentEdit',
    component: () => import('../views/nuoxiaoerAI/article/ArticleAdd.vue'),
    meta: {
      roles: [],
      auth: true,
      title: '文档管理-配置',
      titleEn: 'addDocument'
    }
  },
  {
    path: '/nuoxiaoer-libraryModuleManagement',
    name: 'ArticleModule',
    component: () => import('../views/nuoxiaoerAI/article-module/ArticleModule.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '文库模块管理',
      titleEn: 'library-module-management'
    }
  },
  {
    path: '/nuoxiaoer-articleCatelog',
    name: 'nuoxiaoerArticleCatalog',
    component: () => import('../views/nuoxiaoerAI/article-catalog/ArticleCatalog.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '文章目录管理',
      titleEn: 'wenku-article-catelog'
    }
  },
  {
    path: '/nuoxiaoer-KPIRemark',
    name: 'nuoxiaoerKPIRemark',
    component: () => import('../views/nuoxiaoerAI/kpi-remarks/KpiRemarks.vue'),
    meta: {
      roles: [],
      auth: false,
      title: 'KPI备注管理',
      titleEn: 'wenku-KPI-remark'
    }
  },
  {
    path: '/nuoxiaoer-KPIFolderManagement',
    name: 'nuoxiaoerKPIFolder',
    component: () => import('../views/nuoxiaoerAI/kpi-folder/KpiFolder.vue'),
    meta: {
      roles: [],
      auth: false,
      title: 'KPI目录管理',
      titleEn: 'wenku-KPI-folder-management'
    }
  },
  {
    path: '/nuoxiaoer-KPIContentManagement',
    name: 'nuoxiaoerKPIContent',
    component: () => import('../views/nuoxiaoerAI/kpi-content/KPIContent.vue'),
    meta: {
      roles: [],
      auth: false,
      title: 'KPI考核项内容管理',
      titleEn: 'wenku-KPI-content-management'
    }
  },
  {
    //  诺小二AI行为查询
    path: '/buddyAIStatistics',
    name: 'buddyAIStatistics',
    component: () => import('../views/nuoxiaoerAI/statistics/buddyAIStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '诺小二AI行为日志',
      titleEn: 'buddy AI Statistics'
    }
  },
  {
    path: '/nuoxiaoer-buddyAIStatisticsNew',
    name: 'buddyAIStatisticsNew',
    component: () => import('../views/nuoxiaoerAI/statistics/StatisticsNew.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '诺小二AI行为日志(新版)',
      titleEn: 'buddy AI statistics(new)'
    }
  },
  {
    path: '/nuoxiaoer-notifyManagement',
    name: 'notifyManagement',
    component: () => import('../views/nuoxiaoerAI/notify/NotifyList.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '通知管理',
      titleEn: 'notify management'
    }
  },
  {
    path: '/nuoxiaoer-modulePermissionManagement',
    name: 'modulePermissionManagement',
    component: () => import('../views/nuoxiaoerAI/module-permission/ModulePermissionList.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '权限管理',
      titleEn: 'module permission management'
    }
  },
  {
    path: '/nuoxiaoer-feedbackManagement',
    name: 'feedbackManagement',
    component: () => import('../views/nuoxiaoerAI/feedback/FeedbackList.vue'),
    meta: {
      roles: [],
      auth: false,
      title: '反馈管理',
      titleEn: 'feedback management'
    }
  }
]

export default routes;
